import React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";

interface IUrlListenerProps extends RouteComponentProps {
    children: (location: Location) => JSX.Element;
}

class UrlListener extends React.PureComponent<IUrlListenerProps> {
    render() {
        const {children, location} = this.props;

        // get better typing than -> location: RouteComponentProps["location"]"
        return (
            <React.Fragment>
                {children(location as unknown as Location)}
            </React.Fragment>
        );
    }
}

export default withRouter(UrlListener);
